import { Base } from "../base";
import { Payment } from "../payment";
import { ThrowStmt } from "@angular/compiler";

export class SearchPaymentsQuery extends Base {
    StartDate?: Date;
    EndDate?: Date;
    Target?: string;
    Skip?: number;
    Take?: number;
    OrderBy?: string;
    OrderDesc?: boolean;
    Filters?: SearchFilter[];
    ReturnTotalCount?: boolean;

    constructor(startDate?: Date, endDate?: Date, target?: string) {
        super();
        this.StartDate = startDate;
        this.EndDate = endDate;
        this.Target = target;
    }
}

export class SearchFilter extends Base {
    Field: string;
    Value: string;
    IntValue: number;
    constructor(field: string, value: string) {
        super();
        this.Field = field;
        this.Value = value;
    }
}

export class SearchPaymentsResponse extends Base {
    Items: Array<Payment>;
    TotalCount?: number;
}
